import { useEffect, useMemo, useState } from 'react';

import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import ImageCropper from './ImageCropper';

import './styles/PopupUpdateArticleCover.css';

const PopupUpdateArticleCover = ({ 
  open, 
  image, 
  exitCrop, 
  setCroppedFile,
  setCroppedUrl,
  aspect = 16 / 9,
  continueCrop,
  continueLabel = "Choose",
  exitLabel = "Exit",
  headerText = 'Update Article Cover',
  instructionsText = 'Adjust and crop your article cover',
}) => {
  // Force rectangular crop area
  const cropAreaClass = 'crop-rect';

  const isStringImage = typeof image === 'string';
  const [objectImageUrl, setObjectImageUrl] = useState(null);

  useEffect(() => {
    if (!image || isStringImage) {
      setObjectImageUrl(null);
      return undefined;
    }

    const nextObjectUrl = URL.createObjectURL(image);
    setObjectImageUrl(nextObjectUrl);

    return () => {
      URL.revokeObjectURL(nextObjectUrl);
    };
  }, [image, isStringImage]);

  const imageUrl = useMemo(() => {
    if (!image) return null;
    return isStringImage ? image : objectImageUrl;
  }, [image, isStringImage, objectImageUrl]);
  const resolvedAspect = Number.isFinite(aspect) && aspect > 0 ? aspect : 16 / 9;
  const cropperWidth = 640;
  const cropperHeight = Math.round(cropperWidth / resolvedAspect);

  if (!imageUrl) {
    return null;
  }

  return (
    <GenericPopup
      open={open}
      className={`article-cover-crop-popup ${cropAreaClass}`}
    >
      <div className="article-cover__header">
        <p className="article-cover__header-text">
          {headerText}
        </p>
        <p className="article-cover__instructions">
          {instructionsText}
        </p>
      </div>
      <div className="article-cover__crop-container">
        <ImageCropper
          key={imageUrl}
          source={imageUrl}
          width={cropperWidth}
          height={cropperHeight}
          cropShape="rect"
          aspect={resolvedAspect}
          exitCrop={exitCrop}
          setCroppedFile={setCroppedFile}
          setCroppedUrl={setCroppedUrl}
          continueCrop={continueCrop}
          continueLabel={continueLabel}
          exitLabel={exitLabel}
        />
      </div>
    </GenericPopup>
  );
};

export default PopupUpdateArticleCover;
